<script setup lang="ts">
import { computed } from "vue";

const docUrl = computed(() => import.meta.env.VITE_DOC_URL);
</script>

<template>
  <v-tooltip text="Documentation" location="top">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" icon="mdi-information" color="#FFFFFF" variant="text" :href="docUrl" target="_blank" />
    </template>
  </v-tooltip>
</template>

<style scoped></style>
